import React, { useCallback } from "react";

import ButtonSubmit from "./ButtonSubmit";
import Form from "../ui/Form";
import InputEmail from "./InputEmail";
import InputPassword from "./InputPassword";
import submitLoginAction from "../../../state/actions/ClientActions/submitLoginAction";
import { useDispatch } from "react-redux";

const LoginForm = () => {
    const dispatch = useDispatch();
    const submitLogin = useCallback(() => dispatch(submitLoginAction()), [dispatch]);
    return (
        <Form
            noValidate={true}
            onSubmit={(e: React.FormEvent) => {
                e.preventDefault();
                submitLogin();
            }}
        >
            <InputEmail />
            <InputPassword />
            <ButtonSubmit />
        </Form>
    );
};

export default LoginForm;
